import React from "react";
import './HomePage.css'
import NavBar from '../../Components/NavBar/NavBar';
import Particles from 'react-particles-js';
import ContactPage from "./ContactPage/ContactPage";

const HomePage = () => {

  return (
    <>
      {/* This is home page wrapper outer */}
      <NavBar></NavBar>
      <div id="homePage" className="particleJS">
        <Particles
          params={{
            "particles": {
              "number": {
                "value": 25
              },
              "size": {
                "value": 8
              },
              "line_linked": {
                "enable": true,
                "distance": 150,
                "color": {
                  "value": "#FF9800"
                },
                "opacity": 0.3,
                "width": 5
              },
              "color": {
                "value": '#FF9800'
              }
            },
            "interactivity": {
              "events": {
                "onhover": {
                  "enable": true,
                  "mode": "repulse"
                }
              }
            }
          }} />
      </div>
      <div className="particleDiv">
        <ContactPage></ContactPage>

      </div>



    </>
  );
};

export default HomePage;